import PersistedRolesTable from "./persisted-roles-table.jsx";

export default PersistedRolesTable;